#import "@/apollo/fragments/MasterTemplate.gql"

mutation ResizeMasterTemplate($masterTemplateId: ID!, $campaignId: ID, $width: Int!, $height: Int!) {
    resizeMasterTemplate(masterTemplateId: $masterTemplateId, campaignId: $campaignId, width: $width, height: $height) {
        ...MasterTemplate
    }
}
